import {
  PrimaryRegularButton,
  SecondaryRegularButton
} from 'components/ReusableComponents/Button/RegularButtons'
import Dialog from 'components/ReusableComponents/Dialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import AvailableCodes from 'features/CustomCampaigns/RateCodeFilter/AvailableCodes'
import SelectedCodes from 'features/CustomCampaigns/RateCodeFilter/SelectedCodes'
import { useEffect, useState } from 'react'
import audienceApi from 'services/api/audience'

import styles from './RateCodeFilter.module.scss'

const RateCodeFilter = ({ handleCancel, handleSave, isVisible, savedCodes }) => {
  const [trackingCode, setTrackingCode] = useState()

  const [isLoading, setIsLoading] = useState(true)
  const [rateCodesCount, setRateCodesCount] = useState()

  const [getAllRateCodes, setGetAllRateCodes] = useState(false)

  const [trackingCodes, setTrackingCodes] = useState([])
  const [rateCodes, setRateCodes] = useState({})

  const [selectedRateCodes, setSelectedRateCodes] = useState(
    savedCodes.reduce((acc, code) => {
      return { ...acc, [code]: '' }
    }, {})
  )

  const [filterValue, setFilterValue] = useState()

  function handleChangeFilterValue(value) {
    setFilterValue(value)
    setGetAllRateCodes(false)
  }

  function handleChangeTrackingDropdown(e) {
    setTrackingCode(e.target.value || undefined)
    setGetAllRateCodes(false)
  }

  useEffect(() => {
    audienceApi
      .getRateCodesByTracking({
        trackingCode,
        rateCodeBeginWith: filterValue,
        returnAllRateCodes: getAllRateCodes
      })
      .then(data => {
        if (data.rateCodeUsages) {
          setIsLoading(false)
          if (trackingCodes.length === 0) {
            setTrackingCodes(data.trackingCodeUsages)
          }

          setRateCodes(data.rateCodeUsages)
          setRateCodesCount(data.rateCodesCount)
        }
      })
    // eslint-disable-next-line
  }, [trackingCode, filterValue, getAllRateCodes])

  if (!isVisible) return null

  if (isLoading) return <LoadingIndicator white />

  function selectRateCode({ rateCode, count }) {
    setSelectedRateCodes({ ...selectedRateCodes, [rateCode]: count })
  }

  function removeRateCode({ rateCode }) {
    const { [rateCode]: _removed, ...rest } = selectedRateCodes // eslint-disable-line

    setSelectedRateCodes(rest)
  }

  function removeAllSelected() {
    setSelectedRateCodes({})
  }

  function addAllSelected() {
    setSelectedRateCodes({ ...selectedRateCodes, ...rateCodes })
  }

  return (
    <Dialog>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <AvailableCodes
            onChangeTrackingDropdown={handleChangeTrackingDropdown}
            rateCodes={rateCodes}
            selectedRateCodes={selectedRateCodes}
            onClickCode={selectRateCode}
            addAllCodes={addAllSelected}
            getAllRateCodes={getAllRateCodes}
            onClickGetAll={() => setGetAllRateCodes(true)}
            count={rateCodesCount}
            filterValue={filterValue}
            setFilterValue={handleChangeFilterValue}
            trackingCodes={trackingCodes}
          />
          <div className={styles.seperator}></div>
          <SelectedCodes
            selectedRateCodes={selectedRateCodes}
            onClickCode={removeRateCode}
            removeAllCodes={removeAllSelected}
          />
        </div>
        <div className={styles.controls}>
          <SecondaryRegularButton onClick={handleCancel}>Cancel</SecondaryRegularButton>
          <PrimaryRegularButton
            onClick={() => handleSave(selectedRateCodes)}
            data-testid="submit-rate-codes-button"
          >
            {Object.keys(selectedRateCodes).length === 0
              ? 'Use any rate code'
              : `Use selected ${Object.keys(selectedRateCodes).length} codes`}
          </PrimaryRegularButton>
        </div>
      </div>
    </Dialog>
  )
}

export default RateCodeFilter
